import { FileText, ShieldCheck, Award, GraduationCap, Star, ClipboardCheck, Box, Users, MoreHorizontal } from "lucide-react";

export const CREDENTIAL_TYPE_META = {
  license: { label: "Licenses", singular: "License", icon: FileText, badge: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/20" },
  insurance: { label: "Insurance", singular: "Insurance", icon: ShieldCheck, badge: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/20" },
  certification: { label: "Certifications", singular: "Certification", icon: Award, badge: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/20" },
  training: { label: "Training", singular: "Training", icon: GraduationCap, badge: "bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-500/10 dark:text-violet-400 dark:border-violet-500/20" },
  expertise: { label: "Expertise / Skills", singular: "Expertise / Skill", icon: Star, badge: "bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-500/10 dark:text-cyan-400 dark:border-cyan-500/20" },
  permit: { label: "Permits & Registrations", singular: "Permit & Registration", icon: ClipboardCheck, badge: "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-400 dark:border-indigo-500/20" },
  bond: { label: "Bonds", singular: "Bond", icon: Box, badge: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-500/10 dark:text-orange-400 dark:border-orange-500/20" },
  membership: { label: "Memberships", singular: "Membership", icon: Users, badge: "bg-pink-50 text-pink-700 border-pink-200 dark:bg-pink-500/10 dark:text-pink-400 dark:border-pink-500/20" },
  other: { label: "Other", singular: "Other", icon: MoreHorizontal, badge: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-white/5 dark:text-slate-400 dark:border-white/10" },
};

export const CREDENTIAL_TYPE_ORDER = ["license", "insurance", "certification", "training", "expertise", "permit", "bond", "membership", "other"];

export const CREDENTIAL_STATUS_STYLES = {
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/20",
  "Expiring Soon": "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-400 dark:border-amber-500/20",
  Expired: "bg-red-50 text-red-700 border-red-200 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/20",
  "No Expiration": "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/20",
  Archived: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-white/5 dark:text-slate-400 dark:border-white/10",
};

export const CREDENTIAL_SCOPE_TYPES = ["organization_wide", "individual", "location", "team", "service_area", "jurisdiction"];

export const CREDENTIAL_SCOPE_LABELS = {
  organization_wide: "Organization-wide",
  individual: "Individual",
  location: "Location",
  team: "Team",
  service_area: "Service Area",
  jurisdiction: "Jurisdiction",
};

export const CREDENTIAL_SORT_OPTIONS = [
  { value: "expiration_soonest", label: "Needs Attention (Default)" },
  { value: "expiration_latest", label: "Expiration Date — Latest" },
  { value: "name_asc", label: "Credential Name — A-Z" },
  { value: "name_desc", label: "Credential Name — Z-A" },
  { value: "issue_date_newest", label: "Issue Date — Newest" },
  { value: "recent", label: "Recently Added" },
];

export const formatFileSize = (bytes) => {
  if (!bytes) return "0 KB";
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const scopeReferenceLabel = (credential, meta) => {
  if (!credential.scope_type) return "—";
  if (credential.scope_type === "organization_wide") return "Organization-wide";
  if (credential.scope_type === "individual") return "Individual";
  if (credential.scope_type === "jurisdiction") return credential.scope_reference || "Jurisdiction";
  const list = { team: meta?.teams, location: meta?.locations, service_area: meta?.service_areas }[credential.scope_type] || [];
  const idKey = { team: "team_id", location: "location_id", service_area: "service_area_id" }[credential.scope_type];
  const found = list.find((item) => item[idKey] === credential.scope_reference);
  return found?.name || CREDENTIAL_SCOPE_LABELS[credential.scope_type] || "—";
};
